import React, {useContext, useEffect, useState} from 'react'
import {withRouter} from 'react-router-dom'
import {Page_settings} from '../../config/page_settings'
import strings from '../../lang/strings'
import {observer} from 'mobx-react'
import SidebarLeft from '../../components/sidebar/sidebar_left'
import PageSubHeader from '../../components/common/page_sub_header'
import {MenuMy} from '../../config/page_route'
import {formatNumber} from '../../helper/common'
import ItemPoint from '../../components/item/item_point'
import {rootStore} from '../../mobx/store'
import ReactPaginate from 'react-paginate'
import {PAGECOUNT} from '../../config/const'

const PointList = observer((props) => {
  const context = useContext(Page_settings)
  let [myPoint, setMyPoint] = useState(rootStore.getMe.mb_point)
  let [pageCount, setPageCount] = useState(1)
  let [pointList, setPointList] = useState([])

  const active = 3

  useEffect(() => {
    getPointList(1)
  }, [])

  const getPointList = (page) => {
    context.post('pay/point_list', {page: page, count: PAGECOUNT},
      response => {
        let mb = rootStore.getMe
        mb.mb_point = response.mb_point
        rootStore.signIn(mb)
        setPointList(response.list)
        setPageCount(response.page_count)
      },
      false,
      err => {
        context.showAlert(err.msg)
      }
    )
  }

  const onPointPay = () => {
    context.showPointPay((p) => {onPoint(p)})
  }

  const onPoint = (p) => {
    setMyPoint(p)
    getPointList(1)
  }

  const handlePageClick = (component) => {
    getPointList(component.selected + 1)
  }

  return (
    <React.Fragment>
      <div className='content-container'>
        <SidebarLeft menu={MenuMy} active={active} onPoint={(point) => {onPoint(point)}} history={props.history} />
        <div className='im-container'>
          <PageSubHeader pageName={strings.mypage} pageMenu1={strings.main} pageMenu2={strings.mypage} pageMenu={strings.point_history}/>
          <div className='term-content-area'>
            <div className='fs-20 sm-fs-15 f-b'>{strings.point}</div>
            <div className='coupon-num-area d-flex align-items-center point-num-area'>
              <div className='d-flex align-items-center flex-full'>
                <div className='fs-14 sm-fs-14 f-m self_point'>{strings.self_point}</div>
                <div className='fs-22 sm-fs-20 f-sb color-0a3962 ml-20'>{formatNumber(myPoint) + strings._p}</div>
              </div>
              <div className='btn-point-pay d-center cursor-point sm-mt-12 fs-15 sm-fs-14 f-m' onClick={() => {onPointPay()}}>{strings.point_pay}</div>
            </div>
            <div className='fs-20 sm-fs-16 f-b mb-20 sm-mb-14'>{strings.area}</div>
            {pointList.map((info, idx) => {return (<ItemPoint key={idx} info={info} />)})}
            {pageCount > 1 &&
            <ReactPaginate
              previousLabel={''}
              nextLabel={''}
              breakLabel={'...'}
              breakClassName={'break-me'}
              pageCount={pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageClick}
              containerClassName={'pagination mt-40'}
              subContainerClassName={'pages pagination'}
              activeClassName={'active'}
            />
            }
          </div>
        </div>
      </div>
    </React.Fragment>
  )
})

export default withRouter(PointList)
